export default "__VITE_ASSET__CSLzexpm__"